import { Card, Col, Descriptions, Row, Space, Tag, Typography } from 'antd';
import React from 'react';

import { AuthenticatedUser } from '@/models/auth.model';

const { Paragraph, Title } = Typography;

export interface UserProfilePageProps {
  user: AuthenticatedUser;
}

export const UserProfilePage: React.FC<UserProfilePageProps> = ({ user }) => {
  const value = (text: string): React.ReactNode =>
    text || <Typography.Text type="secondary">Not available</Typography.Text>;

  return (
    <Space direction="vertical" size="large" className="page-stack">
      <Card>
        <Title level={4}>User Profile</Title>
        <Paragraph type="secondary">Your signed-in profile details for this workspace.</Paragraph>
        <Space wrap size="large">
          <Typography.Text strong>Assumed Role:</Typography.Text>
          <Tag color="blue">{user.assumedRole}</Tag>
          <Typography.Text strong>Functional Group:</Typography.Text>
          {user.functionalGroups.length > 0 ? (
            user.functionalGroups.map((group) => <Tag key={group}>{group}</Tag>)
          ) : (
            <Tag>UNCLASSIFIED</Tag>
          )}
        </Space>
      </Card>
      <Row gutter={[24, 24]} align="stretch">
        <Col xs={24} lg={12}>
          <Card style={{ height: '100%' }}>
            <Title level={5}>Identity</Title>
            <Descriptions column={1} bordered>
              <Descriptions.Item label="Display Name">{user.getDisplayName()}</Descriptions.Item>
              <Descriptions.Item label="Email">{user.email}</Descriptions.Item>
              <Descriptions.Item label="First Name">{user.firstName}</Descriptions.Item>
              <Descriptions.Item label="Last Name">{user.lastName}</Descriptions.Item>
              <Descriptions.Item label="User ID">{user.id}</Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card style={{ height: '100%' }}>
            <Title level={5}>Organization</Title>
            <Descriptions column={1} bordered>
              <Descriptions.Item label="Job Title">{value(user.jobTitle)}</Descriptions.Item>
              <Descriptions.Item label="Department / Function">
                {value(user.department)}
              </Descriptions.Item>
              <Descriptions.Item label="Company">{value(user.companyName)}</Descriptions.Item>
              <Descriptions.Item label="Office Location">
                {value(user.officeLocation)}
              </Descriptions.Item>
              <Descriptions.Item label="Employee Type">
                {value(user.employeeType)}
              </Descriptions.Item>
              <Descriptions.Item label="Manager">{value(user.managerName)}</Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>
    </Space>
  );
};

export default UserProfilePage;
